import Flickity from 'flickity';
require('flickity-fade');

class wwdevFlickity extends Flickity {
	activate() {
		super.activate();
		this.element.classList.add('flickity-loaded');
		this.addHideClasses();
	}

	resize() {
		this.element.classList.remove('flickity-loaded');
		this.removeHideClasses();

		super.resize();

		this.element.classList.add('flickity-loaded');
		this.addHideClasses();
	}

	removeHideClasses() {
		this.element.classList.remove('flickity-hide-navigation');
	}

	addHideClasses() {
		if(this.slides.length <= 1) {
			this.element.classList.add('flickity-hide-navigation');
		}
	}
}

export default wwdevFlickity;
